import { Typography, Box } from '@mui/material';

import { theme } from '@verantos-dev/shared-styles';

export type ConceptDetail = {
  id: string;
  attribute: string;
  name: string;
};

/**
 * Card that represents an individual criterion (subject variable)
 * Card content should have the criteria name and type
 */
export const ConceptAccordion = ({ id, attribute, name }: ConceptDetail) => {
  const handleListItemClick = () => {
    // do nothing for now
  };

  return (
    <Box
      key={id}
      id={id}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        margin: '5px',
        '&:hover': {
          backgroundColor: `rgba(204,240,249, 0.608)`,
          cursor: 'pointer',
        },
        padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
        borderRadius: '8px',
        border: `1px solid ${theme.palette.divider}`,
      }}
      onClick={handleListItemClick}
    >
      <Typography sx={{ flexGrow: 1, alignSelf: 'center' }} variant="body1">
        {name}
      </Typography>
      <Typography variant="body1" sx={{ alignSelf: 'center' }}>
        Attribute usage: {attribute}
      </Typography>
    </Box>
  );
};
